import { useEffect } from 'react';
import { useGetMeApi } from 'eds-common/api/v2';

declare global {
  interface Window {
    _mfq: unknown[];
  }
}

export function useMouseflow() {
  const { data: user } = useGetMeApi();

  useEffect(() => {
    if (user?.currentRole === 'student') {
      return undefined;
    }
    // eslint-disable-next-line no-underscore-dangle
    window._mfq = window._mfq || [];
    const mf = document.createElement('script');
    mf.type = 'text/javascript';
    mf.defer = true;
    mf.src =
      '//cdn.mouseflow.com/projects/8486a118-9ec4-4901-a3ff-0f537ee5e3d2.js';
    document.getElementsByTagName('head')[0]?.appendChild(mf);
    return () => {
      if (user?.currentRole !== 'student') {
        document.getElementsByTagName('head')[0]?.removeChild(mf);
      }
    };
  }, [user]);
}
